import React, { Fragment, memo, useCallback, useState } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { SectionCard } from 'src/components/shared/SectionCard'
import { InternalPermission } from 'src/constants/internal-access/internalPermissions'
import { useHasPermission } from 'src/hooks/useHasPermission'
import type { RetryConfigTemplate } from 'src/interfaces/retryConfigTemplate'
import { getRetryConfigTemplatesError } from 'src/selectors/retryConfigTemplate'
import { RetryTemplatesTable } from './RetryTemplatesTable'
import { UpdateRetryTemplateModal } from './UpdateRetryTemplateModal'

/**
 * Deliberately no fetch effect here: the templates count is a TAB SUBTITLE (`SchedulerTabs`), so
 * it has to load whichever tab is active. The fetch lives in `SchedulersManagementPage`.
 */
const RetryTemplatesTabComponent = () => {
  const [editedTemplate, setEditedTemplate] = useState<RetryConfigTemplate | null>(null)

  const templatesError = useSelector(getRetryConfigTemplatesError)

  // PUT …/templates/:retryActionType. Without it the table is read-only (ENG-1207 part 2).
  const canManageTemplates = useHasPermission(InternalPermission.SchedulerTemplatesManage)

  const handleClose = useCallback(() => {
    setEditedTemplate(null)
  }, [])

  return (
    <Fragment>
      {templatesError ? (
        <SectionCard title="Retry config templates">
          <Typography variant="body2" css={tw`text-critical-500`}>
            {templatesError}
          </Typography>
        </SectionCard>
      ) : null}
      <RetryTemplatesTable onRowClick={canManageTemplates ? setEditedTemplate : null} />
      {canManageTemplates ? (
        <UpdateRetryTemplateModal template={editedTemplate} onClose={handleClose} />
      ) : null}
    </Fragment>
  )
}

export const RetryTemplatesTab = memo(RetryTemplatesTabComponent)
